<script setup lang="ts">
import { DATETIME_FORMAT } from '@/utils/dateUtils'
import moment from 'moment'
import { EColors } from '../../../../types/constants/ColorValues'
import type { RentableModel } from '../../../../types/models/RentalModel'
import StackLayout from '../../../Layouts/StackLayout.vue'
import TypographyItem from '../../../Typography/TypographyItem.vue'

type Props = {
    start_date?: Date
    end_date?: Date
    renter_name?: string
    rented_by?: RentableModel
}
defineProps<Props>()
</script>

<template>
    <StackLayout direction="column" :gap="16" class="full-width full-height">
        <slot />

        <StackLayout v-if="renter_name" direction="column" class="rental-class">
            <TypographyItem
                :label="$t('device.rental.renterName')"
                :class="`has-text-${EColors.DANGER} bold`" />
            <TypographyItem :label="renter_name" />
        </StackLayout>

        <StackLayout v-if="rented_by" direction="column" class="rental-class">
            <TypographyItem
                :label="$t('device.rental.rentedByEmail')"
                :class="`has-text-${EColors.DANGER} bold`" />
            <TypographyItem v-if="rented_by.name" :label="rented_by?.name" />
            <TypographyItem v-if="rented_by.email" :label="rented_by?.email" />
        </StackLayout>

        <StackLayout v-if="end_date" direction="column" class="rental-class">
            <TypographyItem
                :label="$t('device.rental.endAt')"
                :class="`has-text-${EColors.DANGER} bold`" />
            <TypographyItem :label="moment(end_date).format(DATETIME_FORMAT)" />
        </StackLayout>
    </StackLayout>
</template>

<style scoped lang="scss">
.rental-class {
    overflow-wrap: anywhere;
    &:deep(.prefix-span) {
        flex-direction: column;
        place-items: start;
    }
}
</style>
